import { useState, useCallback } from 'react';
import { Reactive, useReactor } from '@livefree/reactive';
import { useNavigate } from 'react-router';
import { useRecovery } from '@/features/login/forgot';
import { Animate, useAutoFocus, BackNavigation, StyledTextField } from '@/shared/components';
import { RoutePaths } from '@/routing/RoutePaths';
import { keyPressedHandler } from '@livefree/react-ui';
import { Button, Alert } from '@heroui/react';
import { Uniformly } from '@livefree/uniformly';
import { reactive } from '@/core/reactive/reactive';

export const Forgot = reactive.component(
  ({ services, monitors, isRequired }) => {
    const [message, setMessage] = useState('');
    const recovery = useRecovery();
    const navigate = useNavigate();
    useAutoFocus('username');

    useReactor(services.recovery.requestToken, {
      success: response => {
        const { maskedEmail } = response.payload;
        if (maskedEmail) {
          setMessage('');
          recovery.setEmail(maskedEmail);
          navigate(RoutePaths().login.verify());
        } else {
          setMessage('No user found with that username.');
        }
      },
      error: response => {
        setMessage(response.payload);
      },
    });

    const handleRequest = useCallback(() => {
      if (recovery.username) {
        services.recovery.requestToken(recovery.username);
      }
    }, [services, recovery.username]);

    return (
      <Animate id="forgot">
        <div className="flex flex-col gap-4">
          <BackNavigation title="Reset password" />
          {isRequired && (
            <Alert
              color="primary"
              title="Reset Required"
              description="You're required to change your password to continue"
            />
          )}
          <div className="text-small text-default-500 px-1">
            Enter your username to reset your password.
          </div>
          <Uniformly onChange={form => recovery.setUsername(form.data.username)}>
            <div className="mb-1">
              <StyledTextField
                id="username"
                name="username"
                label="Username"
                type="text"
                variant="bordered"
                onKeyDown={keyPressedHandler('enter', handleRequest)}
                isInvalid={!!message}
                errorMessage={message}
              />
            </div>
          </Uniformly>
          <Button
            color="primary"
            isDisabled={!recovery.username}
            isLoading={monitors.requestToken.executing}
            onPress={handleRequest}
          >
            Email code
          </Button>
        </div>
      </Animate>
    );
  },
  {
    name: 'Forgot',
    monitors: services => [services.recovery.requestToken],
  },
);
